(() => {
  const groups = document.querySelectorAll('[data-ama-choice-group]');
  if (!groups.length) return;

  const setSelected = (card, selected) => {
    card.classList.toggle('is-selected', selected);
    const trigger = card.querySelector('[data-ama-choice-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', selected ? 'true' : 'false');
  };

  groups.forEach((group) => {
    const cards = Array.from(group.querySelectorAll('[data-ama-choice]'));
    cards.forEach((card) => {
      const trigger = card.querySelector('[data-ama-choice-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', () => {
        const shouldSelect = !card.classList.contains('is-selected');
        cards.forEach((item) => setSelected(item, false));
        if (shouldSelect) setSelected(card, true);
      });
    });
  });
})();
